export function initialDataParser(module: string, variables: string[]): Record<string, unknown> {
  return variables.reduce((result: Record<string, unknown>, variableName: string) => {
    const input = document.querySelector(
      `input[name='${module}-${variableName}']`,
    );
    if (input) {
      result[variableName] = JSON.parse(input.getAttribute('value') || '');
    }

    return result;
  }, {});
}

export function initialDataParserFromElement(element: { dataset: DOMStringMap }): Record<string, unknown> {
  return Object.keys(element.dataset).reduce((result: Record<string, unknown>, variableName: string) => {
    try {
      result[variableName] = JSON.parse(element.dataset[variableName] || '');
    } catch (e) {
      result[variableName] = element.dataset[variableName];
    }
    return result;
  }, {});
}
